import React from 'react';
import { Link as LinkScroll } from 'react-scroll';
import styles from './styles.module.scss';

interface ProgressProps {
  minValue: any;
  totalValue: any;
  title: string;
  subtitle: string;
  counter?: string;
}

const Progress: React.FC<ProgressProps> = ({
  title,
  subtitle,
  counter,
  minValue,
  totalValue,
}) => {
  function percentage(partialValue: number, totalValue: number) {
    return (100 * partialValue) / totalValue;
  }

  return (
    <>
      <LinkScroll
        to={'pautas'}
        containerId={'root-container-custom'}
        spy={true}
        smooth={'easeInOutQuart'}
        offset={-210}
        duration={1000}
      >
        <div id={`acompanharVotacao`} className={styles.root}>
          <div className={styles.container}>
            <div className={styles.content}>
              <h1 className={styles.title}>{title}</h1>
              <p className={styles.subtitle}>{subtitle}</p>
              <h1 className={styles.counter}>{counter}</h1>
            </div>
          </div>
          <div className={styles.bar}>
            <div
              className={styles.fill}
              style={{
                width: `${
                  percentage(minValue, totalValue) >= 100
                    ? 100
                    : percentage(minValue, totalValue)
                }%`,
              }}
            />
          </div>
        </div>
      </LinkScroll>
    </>
  );
};

export default Progress;
